import { createSelector } from 'reselect';

const getTicketsStateAccesor = state => state.tickets.tickets;
const getAggentAssistanceAccesor = state => state.tickets.tickets.aggentAssistance;
const getTicketSelectedAccesor = state => state.tickets.tickets.selectedTicket.ticket;
const getDefaultConnectionsTicketSelectedAccesor = state => state.tickets.tickets.selectedTicket.ticket.defaultConnections;
const getFollowingStates = state => state.tickets.tickets.followingStates;
const getParentTicketAccesor = state => state.tickets.tickets.parentTicket;

export const ticketsStateSelector = createSelector(getTicketsStateAccesor, tickets => tickets);
export const aggentAssistanceSelector = createSelector(getAggentAssistanceAccesor, aggentAssistance => aggentAssistance);
export const ticketSelectedSelector = createSelector(getTicketSelectedAccesor, ticketSelected => ticketSelected);
export const followingStatesSelector = createSelector(getFollowingStates, state => state);
export const ticketDefaultConnectionsSelector = createSelector(getDefaultConnectionsTicketSelectedAccesor, state => state);
export const followingFormattedStatesSelector = createSelector(getFollowingStates, state => {
    let stateFormatted = {}
    state.forEach(element => {
        stateFormatted[element.name] = { label: element.name , crmId: element.crmId, value: element.name}
    });
    return  stateFormatted
});
export const parentTicketSelector = createSelector(getParentTicketAccesor, tickets => tickets);